module.exports = __webpack_public_path__ + "static/media/neos.6f0d227a.svg";